export default "__VITE_PUBLIC_ASSET__2d633b84__"